import React from "react";
import {
  getLoginWithRedirectUrl,
  getRegisterWithRedirectUrl
} from "../../../../../lib/auth/authRedirectUrl";
import withTranslations from "../../../../../hocs/withTranslations";
import SquaberLink from "../../SquaberLink/modules/default";

import "../styles/DesktopTagNotFound.scss";

const DesktopTagOnlyForRegisteredUsers = ({ translate, locale }) => (
  <div className="tag-not-found">
    <h4>{translate("Register first")}</h4>
    <p>
      {translate("This desktop is available only for registered users.")}{" "}
      <SquaberLink to={getLoginWithRedirectUrl({ locale })}>
        {translate("Log in")}
      </SquaberLink>{" "}
      {translate("or")}{" "}
      <SquaberLink to={getRegisterWithRedirectUrl({ locale })}>
        {translate("register")}
      </SquaberLink>
    </p>
  </div>
);

export default withTranslations(DesktopTagOnlyForRegisteredUsers);
